export default __webpack_public_path__ + "static/hikoki-9a8c55befd77094101f4d826d5aca441.jpg";